import { Grid } from "@material-ui/core"
import { WidgetEconomicalData } from "../Widgets/WidgetEconomicalData"
import { useRevenueParams } from "../../hooks/useRevenueParams"
import { BillingType } from "../../types"

export type EconomicalDataBoxType = {
  revenue: number
  growth: number
  currency: string
  billings?: BillingType
}

export function EconomicalDataBox({ data }: { data?: EconomicalDataBoxType }) {
  const { hasClientViewParamSelected } = useRevenueParams()
  return (
    <Grid container spacing={4}>
      <Grid item xs={6}>
        <WidgetEconomicalData
          data={{
            value: data?.revenue,
            growth: data?.growth,
            currency: data?.currency,
          }}
          type={"revenue"}
        />
      </Grid>
      <Grid item xs={6}>
        {!hasClientViewParamSelected ? (
          <WidgetEconomicalData
            data={{
              value: data?.billings?.value,
              growth: data?.billings?.growth,
              currency: data?.currency,
            }}
            type={"billings"}
          />
        ) : null}
      </Grid>
    </Grid>
  )
}
